import * as R from 'ramda';
import { createSelector } from 'reselect';
// report-common
import { getReportSelectors } from '../../report-common';
//////////////////////////////////////////////////

const {
  store,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectTitleSortValues,
  makeSelectTableTitleFilters,
} = getReportSelectors('masterAudit');

const makeSelectItemList = () => createSelector(
  store,
  ({ itemList }) => R.compose(
    R.sortBy(R.prop('index')),
    R.values,
  )(itemList),
);

export {
  makeSelectItemList,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectTitleSortValues,
  makeSelectTableTitleFilters,
};
